import * as React from "react";
import {Field} from "react-final-form";

export default class InputTextBox extends React.Component<InputTextBoxProps, any> {

    render() {
        const {name, className, placeholder, maxLength, tamano} = this.props;
        return (
            <Field name={name}>
                {({input, meta}) => (
                    <div>
                        <textarea {...input} placeholder={placeholder} maxLength={maxLength}
                                style={{ height: tamano }} 
                               className={className ? className.concat(" form-control") : "form-control"}/>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}

interface InputTextBoxProps {
    name: string,
    tamano: number,
    className?: string,
    placeholder?: string,
    maxLength?: number
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/InputTextBox.tsx